import { normalizeResultLabel } from './resultLocalization';

const RICE_GRAIN_IDS = new Set(['18', '27']);

const RICE_INDI_GRAIN_LABEL_KEYS = new Set([
  'resultLabelSerial',
  'resultLabelImage',
  'grainLength',
  'grainWidth',
  'resultLabelBroken',
]);

const NON_RICE_INDI_GRAIN_LABEL_KEYS = new Set([
  'resultLabelSerial',
  'resultLabelImage',
  'grainLength',
  'grainArea',
]);

export const normalizeGrainId = (grainId: string | number | undefined | null) => {
  if (grainId === undefined || grainId === null) {
    return undefined;
  }

  return String(grainId);
};

export const isLightboxFeatureEnabled = (
  settings: { lightbox_enabled?: boolean } | null | undefined
) => settings?.lightbox_enabled === true;

export const isRiceLikeGrain = (
  grainId: string | number | undefined | null,
  grainName?: string | null
) => {
  const normalizedGrainId = normalizeGrainId(grainId);
  if (normalizedGrainId && RICE_GRAIN_IDS.has(normalizedGrainId)) {
    return true;
  }

  if (!grainName) {
    return false;
  }

  return grainName.trim().toLowerCase().includes('rice');
};

export const isAllowedIndiGrainColumn = (header: unknown, isRice: boolean) => {
  const normalizedLabel = normalizeResultLabel(header);
  if (!normalizedLabel) {
    return false;
  }

  const allowedLabels = isRice ? RICE_INDI_GRAIN_LABEL_KEYS : NON_RICE_INDI_GRAIN_LABEL_KEYS;
  return allowedLabels.has(normalizedLabel);
};
